/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Filter_OtherInputs */



/**
* | output |
* | --- |
* | "Other" |
*
* @param {Agenda_Filter_OtherInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_filter_other = /** @type {((inputs?: Agenda_Filter_OtherInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Filter_OtherInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Overig")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autres")
	return /** @type {LocalizedString} */ ("Other")
});